import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center gap-4" }
const _hoisted_2 = { class: "flex flex-col place-items-center overflow-hidden" }
const _hoisted_3 = ["src"]

import BaseCard from '@/features/global/BaseCard.vue';
import FFGif from '@/assets/Projects/FinalFantasyPhotos/FFGif.gif';
import { useImageViewer } from '@/features/composables/useImageViewer';


export default /*@__PURE__*/_defineComponent({
  __name: 'FinalFantasyProjectSpec',
  setup(__props) {

const { openImageMenu } = useImageViewer();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseCard, {
    title: 'RPG Battle Simulator',
    highlightLastWord: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "w-full grid lg:grid-cols-2 lg:gap-20" }, [
          _createElementVNode("h5", { class: "lg:justify-self-end lg:pr-6 font-medium" }, "Solo Engineer"),
          _createElementVNode("h5", { class: "lg:justify-self-start lg:pl-6 font-medium" }, "April 2025 - May 2025")
        ], -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-center items-center px-4 gap-2" }, [
          _createElementVNode("span", { class: "block" }, " One of my favorite parts of taking on a new project is becoming so invested in it that it's near impossible to stop. The ideas just keep on flowing and I can't seem to break away from the keyboard, which is exactly the case with this project. "),
          _createElementVNode("span", { class: "block" }, [
            _createTextVNode(" What I originally intended to be a short, 10-hour project to develop a small interface to do a single turn of battle turned into a 75-hour project. In just over a week, I designed 6 player classes, 2 unique sprites, 2 menus, and 6 animations for each move, all within the painfully simple "),
            _createElementVNode("a", {
              href: "https://www3.nd.edu/~dthain/courses/cse20211/fall2013/gfx/",
              class: "link-in-text",
              target: "_blank"
            }, "GFX"),
            _createTextVNode(" library that can't do more than draw a single shape at a time. I learned that I needed to clear and redraw the entire screen to animate moving frames, yet it was all worth it for the final product. I still sometimes play it to this day! ")
          ]),
          _createElementVNode("a", {
            href: "https://youtu.be/EPzwJwWxlPI",
            target: "_blank",
            class: "link-in-text"
          }, "Watch a demo!")
        ], -1)),
        _createElementVNode("span", _hoisted_2, [
          _createElementVNode("img", {
            class: "rounded-lg w-full h-auto cursor-pointer",
            src: _unref(FFGif),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openImageMenu)(_unref(FFGif), 'Battle Sim Short Demo', $event.currentTarget))),
            style: {"width":"40%","margin":"auto"}
          }, null, 8, _hoisted_3)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})